<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.id }} — {{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const DAMAGES = 'get_damages.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'damages',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: '',
			id: null
		},
		methods: {
			change () {
				EventBus.$emit(`damages`, {index: this.line_count, value: this.selected})
			}
		},
		mounted () {
			fetch(DB + DAMAGES, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = [{id: '', name: ''}, ...data];
					if(this.id) {
						this.selected = this.id
					}
					
				}
				else {
					this.options = []
					this.selected = '0'
				}
			})
			.catch(err => console.log(err))
		},
	}
</script>


// WEBPACK FOOTER //
// damages.vue?cd192e18